import { HUBBLE_API_TOKEN } from '../store/middleware/APIUrl'

/**
 * Gets an endpoint's url base from opts object
 * @param {Object} [opts] Options
 * @param {String} [opts.url] Prefix of the url to be called
 * @param {String} [name] Name of the callback
 */
function getCallbackFromOpts(opts, name) {
    if (opts && typeof opts === 'object') {
        const { [name]: callback } = opts

        if (callback && typeof callback === 'function') {
            return callback
        }
    }

    return () => null
}

/**
 * Gets an endpoint's url base from opts object
 * @param {Object} [opts] Options
 * @param {String} [opts.url] Prefix of the url to be called
 */
function getUrlFromOpts(opts) {
    if (opts && typeof opts === 'object') {
        const { url } = opts

        if (url) {
            return url
        }
    }

    return HUBBLE_API_TOKEN
}

export { getCallbackFromOpts, getUrlFromOpts }
